/** Format a driving duration in minutes as "45 min", "1 hr 25 min" or "2 hr". */
export const formatDuration = (minutes) => {
  if (minutes == null || isNaN(minutes)) return null;
  const total = Math.round(Number(minutes));
  if (total < 60) return `${total} min`;
  const h = Math.floor(total / 60);
  const m = total % 60;
  return m === 0 ? `${h} hr` : `${h} hr ${m} min`;
};
